module.exports = __webpack_public_path__ + "img/fireworks.5b7abfe3.gif";